var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F8EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.0001 0C11.7567 0 11.5152 0.00811267 11.2754 0.0224064C17.5653 0.397183 22.2428 5.61595 22.2428 12C22.2428 18.384 17.5653 23.6028 11.2754 23.9776C11.5152 23.9919 11.7567 24 12.0001 24C18.6275 24 24.0001 18.6274 24.0001 12C24.0001 5.37257 18.6275 0 12.0001 0Z",
    fill: "#F8EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12 22.2432C17.6569 22.2432 22.2427 17.6574 22.2427 12.0005C22.2427 6.34362 17.6569 1.75781 12 1.75781C6.34313 1.75781 1.75732 6.34362 1.75732 12.0005C1.75732 17.6574 6.34313 22.2432 12 22.2432Z",
    fill: "url(#paint0_linear_2001_4854)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12 1.75781C11.7564 1.75781 11.5148 1.76694 11.2754 1.78365C16.5941 2.15548 20.7934 6.58732 20.7934 12.0005C20.7934 17.4137 16.5941 21.8455 11.2754 22.2174C11.5148 22.2341 11.7564 22.2432 12 22.2432C17.6569 22.2432 22.2427 17.6574 22.2427 12.0005C22.2427 6.34365 17.6569 1.75781 12 1.75781Z",
    fill: "#49028E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M18.1955 9.9401L11.6576 16.4785C10.9642 17.1715 9.84094 17.1715 9.14798 16.4785L5.8044 13.1349C5.42002 12.751 5.42002 12.1281 5.8044 11.7442L6.77889 10.7697V10.7692L7.10919 10.4389C7.4931 10.055 8.11603 10.055 8.49994 10.4389L10.1732 12.1122C10.3528 12.2923 10.645 12.2923 10.8246 12.1122L15.5961 7.34066C15.98 6.95676 16.603 6.95676 16.9869 7.34066L18.1955 8.54935C18.5799 8.93374 18.5799 9.5562 18.1955 9.9401Z",
    fill: "#F8EEFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M10.8245 12.1116L10.2706 12.6654C10.0524 12.8842 9.69841 12.8856 9.47772 12.6688L7.7842 11.0062C7.51233 10.7339 7.1207 10.6556 6.77881 10.7691V10.7686L7.10911 10.4383C7.49301 10.0544 8.11595 10.0544 8.49985 10.4383L10.1731 12.1116C10.3527 12.2917 10.6449 12.2917 10.8245 12.1116Z",
    fill: "#F8EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M18.1956 8.54956L16.9868 7.34077C16.6027 6.95672 15.9801 6.95672 15.596 7.34077L15.2835 7.6533C15.5649 7.62708 15.8553 7.72154 16.0707 7.93696L16.7463 8.54961C17.1303 8.93366 17.1303 9.5563 16.7463 9.94035L10.7502 16.0151C10.3221 16.4432 9.72972 16.6065 9.17603 16.5056C9.87096 17.1711 10.9735 17.1625 11.6572 16.4787L18.1956 9.94035C18.5796 9.5563 18.5796 8.93361 18.1956 8.54956Z",
    fill: "#F8EEFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2001_4854",
    x1: 12,
    y1: 1.75781,
    x2: 12,
    y2: 23.0879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9027E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58297B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPass);
export default __webpack_public_path__ + "static/media/icon_pass.6e4342fc691358bfe7aed63804ebf40e.svg";
export { ForwardRef as ReactComponent };